import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";

import { ChooseReportTemplate } from "@/features/Reports/new/ChooseReportTemplate";
import { ReportTemplatesQuery } from "@/features/Reports/new/graphql";
import { WizardPage } from "@/features/Reports/new/WizardPage";

export const Route = createFileRoute("/$organizationKey/$dossierId/reports/new/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey } = Route.useParams();
  const { data } = useSuspenseQuery(ReportTemplatesQuery, { variables: { organizationKey } });

  return (
    <WizardPage step="template">
      <ChooseReportTemplate templates={data.organization.reportTemplates} />
    </WizardPage>
  );
}
